// extracted by mini-css-extract-plugin
module.exports = {"animatedWrapper":"NumberLoader_animatedWrapper__xrlZI","animatedNumbers":"NumberLoader_animatedNumbers__t_1SM","loaderBlock":"NumberLoader_loaderBlock__ZnfaA"};